import React from 'react'

export default function CalendarIcon(props) {
  return (
    <svg width={18} height={20} viewBox="0 0 18 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.963 3.81H6.03v.72a.742.742 0 01-1.484 0v-.72H3.024a.948.948 0 00-.947.948v11.951c0 .523.425.948.947.948h11.952a.948.948 0 00.948-.948V4.758a.948.948 0 00-.948-.947h-1.53v.718a.742.742 0 01-1.483 0v-.718zm0-1.483v-.756a.742.742 0 111.483 0v.756h1.53c1.34 0 2.43 1.09 2.43 2.43V16.71c0 1.34-1.09 2.43-2.43 2.43H3.024c-1.34 0-2.43-1.09-2.43-2.43V4.758c0-1.34 1.09-2.43 2.43-2.43h1.522V1.57a.742.742 0 111.484 0v.756h5.933zM13.72 8.73H4.295a.742.742 0 010-1.484h9.425a.742.742 0 110 1.484z"
        fill="#24206B"
      />
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/app/elements/Icons/CalendarIcon.js